const USERS = 'users';

export const users = () => [USERS];
